import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation({
      query: (body: { userName: string; password: string }) => {
        return {
          url: "/user/login",
          method: "POST",
            headers: {
              "device-id": deviceId,
            },
          body,
        };
      },
      transformResponse: (response: any) => {
        return { ...response, data: { ...response?.data, deviceId } };
      },
    }),

    // Get Access Token
    getAccessToken: builder.mutation({
      query: (body) => {
        return {
          url: "/user/refresh-token",
          headers: {
            "device-id": deviceId,
          },
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useLoginMutation, useGetAccessTokenMutation } = authApi;
